<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
       <el-form-item label="退货收件人：" prop="refundRecipient">
          <el-input style="width: 424px;" v-model="ruleForm.refundRecipient" placeholder="请输入退货收件人"></el-input>
        </el-form-item>
        <el-form-item label="退货联系方式：" prop="refundPhone">
          <el-input style="width: 424px;" v-model="ruleForm.refundPhone" placeholder="请输入退货联系方式"></el-input>
        </el-form-item>
        <el-form-item label="退货地址：" prop="refundAddress">
          <el-input style="width: 424px;" v-model="ruleForm.refundAddress" placeholder="请输入退货地址"></el-input>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveSeleniumJourneyConfig, fetchSeleniumJourneyConfigDetail } from '@/api/journeySetting'
export default {
  name: 'System',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      ruleForm: {
         refundRecipient:'',
         refundPhone:'',
         refundAddress:'',
      },
      rules: {
        refundRecipient: [
          { required: true, message: '请输入退货收件人', trigger: 'blur' }
        ],
        refundPhone: [
          { required: true, message: '请输入退货联系方式', trigger: 'blur' }
        ],
        refundAddress: [
          { required: true, message: '请输入退货地址', trigger: 'blur' }
        ],
      }
    }
  },
  mounted () {
    var that = this;
    fetchSeleniumJourneyConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.refundRecipient = data.refundRecipient
        that.ruleForm.refundPhone = data.refundPhone
        that.ruleForm.refundAddress = data.refundAddress
      }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let refundRecipient = that.ruleForm.refundRecipient
      let refundPhone = that.ruleForm.refundPhone
      let refundAddress = that.ruleForm.refundAddress
      if(refundRecipient == ''){
        this.$message.error('请输入退货收件人')
        return false
      }
      if(refundPhone == ''){
        this.$message.error('请输入退货联系方式')
        return false
      }
      if(refundAddress == ''){
        this.$message.error('请输入退货地址')
        return false
      }
      that.fullscreenLoading = true
      saveSeleniumJourneyConfig({refundRecipient:refundRecipient,refundPhone:refundPhone,refundAddress:refundAddress}).then((res) => {
         that.fullscreenLoading = false
         that.backDataFun(res)
      });
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/Refund.vue